const CHANGE_LOAD = 'CHANGE_LOAD';

module.exports = {
    CHANGE_LOAD
}